export enum VerifyMobileNumberType {
  SMS = 1,
  Whatsapp = 2,
  Email = 3,
}
